import React, {useEffect, useState} from 'react';
import Nav from "react-bootstrap/Nav";

import {OffCanvasMenu} from "./OffCanvasMenu";
import {Menu} from "./Menu";
import {Logo} from "./Logo";
import {LangSwitcher} from "./global/LangSwitcher";
import {useACFOptions} from "./_hooks/useACFOptions";
import {useI18next, Link} from 'gatsby-plugin-react-i18next';
import introImg from "../images/rbtc/bitcoin.svg";

export const Header = ({translations}) => {

  const {footer, header} = useACFOptions();;
  const contact = header?.contactLink;
  const bridge = header?.bridgeLink;
  const {language} = useI18next();

    // Add state to track whether the banner should be visible
    const [showBanner, setShowBanner] = useState(true);

    useEffect(() => {
      const handleScroll = () => {
        const scrollPercentage = (window.scrollY / document.body.scrollHeight) * 100;
        setShowBanner(scrollPercentage <= 10);
      };

      // Attach the scroll event listener
      window.addEventListener("scroll", handleScroll);

      // Clean up the event listener when the component is unmounted
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []); // Empty dependency array ensures this effect runs only once

  return (
    <header className={`header py-3 py-md-4 position-fixed ${showBanner ? 'pb-md-0' : ''}`}>
      <a
        className="visually-hidden-focusable btn position-absolute btn-primary"
        href="#main">
        Skip to content
      </a>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-5">
            <Nav className="p-0 navbar navbar-expand-lg d-none d-lg-flex">
              <Menu/>
            </Nav>
          </div>
          <div className="col-lg-3 col-6 d-flex justify-content-start">
            <Link aria-label="Home Page" to="/" lang={language}>
              <Logo/>
            </Link>
          </div>
          <div className="col-lg-4 col-6 d-flex justify-content-end align-items-center">
            <LangSwitcher translations={translations} />
              <a className="btn btn-outline-white btn-sm d-none d-lg-block me-3" rel="noopener noreferrer" href={bridge.url}>
              {bridge.title} <img src={introImg} className="rbtc icon" alt="rbtc icon" width="25" height="25" loading="lazy"/>
              </a>
            <OffCanvasMenu copy={footer?.copyright} contact={contact}/>
          </div>
        </div>
      </div>


    </header>
  );
};
